import { mapActions } from 'vuex';

export default {
  methods: {
    alertError(error) {
      this.setAlert({
        color: 'error',
        message: error.response ? error.response.data.message : error.message
      });
    },

    alertSuccess(message) {
      this.setAlert({
        color: 'success',
        message
      });
    },

    ...mapActions(['setAlert'])
  }
};
